import jwtDecode from 'jwt-decode';
import config from 'config';
import {AUTHENTICATE_USER, GET_USER_DATA_SUCCEEDED, UPDATE_USER_DATA, USER_LOGOUT,} from './actionTypes';
import {eraseCookie, getCookie} from '../../utils/CookieManager';
import {validJWT} from '../../utils/General';

const getUserInitialState = () => {
    const token = getCookie(config.jwtAuthToken) ? getCookie(config.jwtAuthToken) : null;

    const isValidToken = validJWT(token);

    let userData = {
        isAuthenticated: isValidToken,
        isAuthenticating: false,
        initialInfoFetched: false,
        token,
        role: {},
        language: config.localeValues.english,
        firstName: null,
        lastName: null,
        sub: null,
        thumbUrl: null,
        phone: null,
        error: null,
        subCompanyIds: [],
    };

    if (isValidToken) {
        userData = Object.assign(userData, getUserInfoFromToken(token));
    } else {
        eraseCookie(config.jwtAuthToken);
    }

    return userData;
};

export function getUserInfoFromToken(token) {
    const tokenData = jwtDecode(token);
    return {
        id: tokenData ? tokenData.id : null,
        companyId: tokenData ? tokenData.companyId : null,
        authorities: tokenData ? tokenData.authorities : null,
        contact: tokenData,
        firstName: tokenData.firstName,
        lastName: tokenData.lastName,
        sub: tokenData.sub,
        thumb: tokenData.thumb,
        phone: tokenData.phone,
    };
}

export default function user(state = getUserInitialState(), action) {
    switch (action.type) {
        case AUTHENTICATE_USER: {
            const {token} = action;
            return Object.assign({}, state, {
                isAuthenticated: true,
                token: action.token,
            }, getUserInfoFromToken(token));
        }

        case GET_USER_DATA_SUCCEEDED: {
            return Object.assign({}, state, action.userData, {
                initialInfoFetched: true,
            });
        }

        case UPDATE_USER_DATA:
            return Object.assign({}, state, action.payload.updateData);

        case USER_LOGOUT: {
            return Object.assign({}, state, getUserInitialState());
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/user/reducer.js